import React from "react";
import { Grid, Typography, Box, Button } from "@material-ui/core";
import { Localizations } from "../../../Shared/sharedTypes";
import { ImageLocalizationResource } from "../../../Shared/Auto/Interfaces/ImageLocalizationResource";

type PropTypes = {
    localizations: Localizations;
    images: Array<ImageLocalizationResource>;
};

function IOSDenied({ localizations, images }: PropTypes) {
    return (
        <>
            <Grid item className="PhaseTopSection">
                <Box m={3}>
                    <Typography variant="h5">{localizations.appleDeniedMainHeader}</Typography>
                    <Typography variant="body1">{localizations.appleDeniedMainBody}</Typography>
                    <img alt="" style={{ width: "100%" }}
                        src={images.find(x => x.description == "Initial Image")?.url ?? "/images/permissionsBlockedGeneral.png"} />
                    <br />
                    <br />
                    <Typography variant="h6">{localizations.appleDeniedSitePermissionsHeader}</Typography>
                    <Typography variant="body1">{localizations.appleDeniedSitePermissionsStep1}</Typography>
                    <br />
                    <img
                        alt="Location of menu in Safari for fixing site permission issues"
                        src={images.find(x => x.description == "Change Site Permissions - Step 1")?.url ?? "/images/iosSiteIcon.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedSitePermissionsStep2}</Typography>
                    <br />
                    <img
                        alt="Location of option in menu within Safari for fixing site permission issues"
                        src={images.find(x => x.description == "Change Site Permissions - Step 2")?.url ?? "/images/iosPopoutSettings.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedSitePermissionsStep3}</Typography>
                    <br />
                    <img
                        alt="Actual screen for resolving site permission issues in Safari"
                        src={images.find(x => x.description == "Change Site Permissions - Step 3")?.url ?? "/images/iosSiteSettings.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="h6">{localizations.appleDeniedLocationServicesHeader}</Typography>
                    <Typography variant="body1">{localizations.appleDeniedLocationServicesBody}</Typography>
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedLocationServicesStep1}</Typography>
                    <br />
                    <img
                        alt="Location of privacy within iOS settings"
                        src={images.find(x => x.description == "Change App Permissions - Step 1 Image 1")?.url ?? "/images/iosPrivacySettingsMain.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <img
                        alt="Location of location services options within the privacy menu"
                        src={images.find(x => x.description == "Change App Permissions - Step 1 Image 2")?.url ?? "/images/iosLocationServicesMain.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedLocationServicesStep2}</Typography>
                    <br />
                    <img
                        alt="Location of button to turn on location services for an iOS device"
                        src={images.find(x => x.description == "Change App Permissions - Step 2")?.url ?? "/images/iosLocationServices.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedLocationServicesStep3}</Typography>
                    <br />
                    <img
                        alt="Location of Safari specific settings under location services"
                        src={images.find(x => x.description == "Change App Permissions - Step 3")?.url ?? "/images/iosSafariWebsitesMain.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedLocationServicesStep4}</Typography>
                    <br />
                    <img
                        alt="Actual screen for resolving app permission issues with Safari"
                        src={images.find(x => x.description == "Change App Permissions - Step 4")?.url ?? "/images/iosSafariWebsitesSelection.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.appleDeniedFinalStep}</Typography>
                    <br />
                    <br />
                </Box>
            </Grid>
            <Grid item className="footer" alignContent="flex-start" justify="space-between" container direction="row">
                <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => window.location.reload()}
                >
                    {localizations.appleDeniedReloadPage}
                </Button>
            </Grid>
        </>
    );
}

export default IOSDenied;
